<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <ul class="vx-timeline">
    <li v-for="item in timelineData" :key="item.id">
      <div :class="`timeline-icon ${item.activity_type}`">
        <vs-tooltip :text="item.activity_type">
          <span :class="`material-icons-outlined ${item.activity_type}-text`">
            {{ renderIcon(item.activity_type) }}
          </span>
        </vs-tooltip>
      </div>

      <div class="timeline-info">
        <div class="flex flex-1 justify-between">
          <p class="font-semibold">{{ getDescription(item) }}</p>
          <small
            class="text-grey activity-e-time"
            v-if="beforeADay(item.created_at)"
            >{{ item.created_at }}</small
          >
          <small class="text-grey activity-e-time" v-else>{{
            item.created_at | formatTimeAgo
          }}</small>
        </div>
        <span class="activity-desc">{{ item.comment }}</span>
        <div class="flex flex-1 mt-4 chip_row">
          <vs-chip color="success" v-if="item.activity_result_id == 1">
            Interested
          </vs-chip>
          <vs-chip color="danger" v-if="item.activity_result_id == 3">
            Not Interested
          </vs-chip>
          <vs-chip v-if="item.activity_result_id == 2"> Not Decided </vs-chip>

          <vs-chip class="reminder_date_time_chip" v-if="item.has_reminder">
            {{ item.reminder_date | dateFormatLocalization }} at
            {{
              `${item.reminder_date} ${item.reminder_time}`
                | timeFormatLocalization
            }}
          </vs-chip>
          <vs-tooltip
            v-if="item.has_reminder && item.reminder_note"
            :text="item.reminder_note"
          >
            <vs-chip class="reminder_note_chip">
              {{ item.reminder_note | truncateString }}
            </vs-chip>
          </vs-tooltip>
        </div>

        <div class="flex flex-1 mt-4 files_row" v-if="item.files.length > 0">
          <div
            class="files mx-1 cursor-pointer"
            v-for="file in item.files"
            :key="file.files_id"
          >
            <div
              class="image"
              v-if="
                file.file_type === 'image/jpeg' ||
                file.file_type === 'image/png'
              "
            >
              <img @click="downloadImage(file)" :src="file.file_path" />
            </div>

            <div
              class="text"
              @click="downloadImage(file)"
              v-else-if="file.file_type === 'text/plain'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="file-word"
                class="svg-inline--fa fa-file-word fa-w-12"
                role="img"
                viewBox="0 0 384 512"
              >
                <path
                  fill="currentColor"
                  d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
                />
              </svg>
            </div>

            <div
              class="pdf"
              @click="downloadImage(file)"
              v-else-if="file.file_type === 'application/pdf'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="file-pdf"
                class="svg-inline--fa fa-file-pdf fa-w-12"
                role="img"
                viewBox="0 0 384 512"
              >
                <path
                  fill="currentColor"
                  d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
                />
              </svg>
            </div>

            <div
              class="excel"
              @click="downloadImage(file)"
              v-else-if="
                file.file_type ===
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="file-excel"
                class="svg-inline--fa fa-file-excel fa-w-12"
                role="img"
                viewBox="0 0 384 512"
              >
                <path
                  fill="currentColor"
                  d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
                />
              </svg>
            </div>

            <div
              class="text"
              @click="downloadImage(file)"
              v-else-if="file.file_type === 'video/mp4'"
            >
              <video class="cstm-card-img" :src="item.file_path"></video>
            </div>

            <div class="general" @click="downloadImage(file)" v-else>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="file-alt"
                class="svg-inline--fa fa-file-alt fa-w-12"
                role="img"
                viewBox="0 0 384 512"
              >
                <path
                  fill="currentColor"
                  d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import axios from "axios";

export default {
  name: "vx-timeline",
  props: {
    timelineData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    timelineData(newValue) {
      return newValue;
    },
  },
  filters: {
    truncateString(value) {
      if (value.length > 36) {
        return `${value.substring(0, 36)}  ...more`;
      } else {
        return value;
      }
    },
  },
  methods: {
    beforeADay(date) {
      let diffInMilliSeconds =
        Math.abs(new Date().getTime() - new Date(date).getTime()) / 1000;

      const hours = Math.floor(diffInMilliSeconds / 3600);
      console.log(hours > 24, diffInMilliSeconds, date);
      return hours > 24;
    },
    renderIcon(activity_type) {
      const iconSet = [
        { type: "chat", icon: "question_answer" },
        { type: "note", icon: "text_snippet" },
        { type: "call", icon: "call" },
        { type: "sms", icon: "sms" },
        { type: "email", icon: "email" },
        { type: "Create", icon: "contacts" },
        { type: "Edit", icon: "contacts" },
        { type: "convertLead", icon: "contacts" },
      ];

      return iconSet.find((activity) => activity.type === activity_type).icon;
    },
    getDescription(item) {
      const action_person_name = `${item.user_details.first_name} ${item.user_details.middle_name} ${item.user_details.last_name}`;

      if (item.activity_type === "Create") {
        return `Created by ${action_person_name}`;
      } else if (item.activity_type === "Edit") {
        return `Lead has been edited by ${action_person_name}`;
      } else if (item.activity_type === "Convert Lead") {
        return `Lead has been converted by ${action_person_name}`;
      } else {
        return item.description;
      }
    },
    async downloadImage(item) {
      try {
        const response = await axios({
          url: `${item.file_path}`,
          method: "GET",
          responseType: "blob",
          headers: { "Access-Control-Allow-Origin": "*" },
        });

        const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");
        fileLink.href = fileUrl;

        fileLink.setAttribute("download", item.file_name);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
<style>
.timeline-icon {
  background-color: #ffffff !important;
  border: 1px solid;
}

.activity-e-time {
  min-width: 71px !important;
}

.chip_row > .con-vs-chip {
  cursor: default;
}

.reminder_date_time_chip {
  color: rgba(var(--vs-primary), 1) !important;
}

.reminder_note_chip {
  cursor: default;
}

.chat {
  border-color: rgba(var(--vs-success), 1);
}

.chat-text {
  color: rgba(var(--vs-success), 1);
}

.note {
  border-color: rgba(var(--vs-secondary), 1);
}

.note-text {
  color: rgba(var(--vs-secondary), 1);
}

.email {
  border-color: rgba(var(--vs-warning), 1);
}

.email-text {
  color: rgba(var(--vs-warning), 1);
}

.sms {
  border-color: rgba(var(--vs-danger), 1);
}

.sms-text {
  color: rgba(var(--vs-danger), 1);
}

.call {
  border-color: rgba(var(--vs-primary), 1);
}

.call-text {
  color: rgba(var(--vs-primary), 1);
}

.files .image img {
  width: 20px;
  height: 25px;
}
.files .pdf svg {
  color: red;
}
.files .general svg {
  color: aqua;
}
.files .excel svg {
  color: green;
}
.files .text svg {
  color: blue;
}
.files svg {
  width: 20px;
}
</style>
